import React from "react";
import Footer from "../footer/Footer";
import Navigation from "../nav/Navigation";

export default function Layout({ project = false, children }) {
    return (
        <>
            <div className="flex flex-col w-screen h-screen overflow-auto text-gray-700 bg-gradient-to-tr from-blue-200 via-indigo-200 to-pink-200">
                <Navigation project={project} />
                {children}
            </div>
            <Footer />
        </>
    );
}
